// extracted by mini-css-extract-plugin
export default {"imageContainer":"V2-z","summaryPar":"W2-z","ratingCategories":"X2-z","reviewerInfo":"Y2-z","reviewTypes":"Z2-z","expanded":"_2-z"};